<template>
    <full-screen-overlay @close="exit" backTo="Project">

        <dashboard-header header="Edit your user settings" description="Update your name, account email address and profile picture."/>

        <div class="w-full mt-8" v-if="me">
            <FormulateForm name="user-settings" :values="me" @submit="updateUser" class="max-w-screen-xs">
                <label class="text-sm text-gray-500 leading-8" for="name">Your name...</label>
                <base-input autofocus required placeholder="Type name of collection..." id="name" name="name" class="mb-6" />

                <label class="text-sm text-gray-500 leading-8" for="email">Your email...</label>
                <span v-show="errors.email" class="text-sm text-error mb-2 block">{{ errors.email }}</span>
                <base-input required placeholder="Enter new email..." id="email" type="email" name="email" class="mb-6" />
                

                <label class="text-sm text-gray-500 leading-10">Change profile image...</label>

                <FormulateInput
                    type="image"
                    name="file"
                    validation="mime:image/jpeg,image/png,image/jpg"
                    accept="mime:image/jpeg,image/png,image/jpg"
                    upload-behavior="delayed"
                    :uploader="uploadFile"
                />

            <base-button bgColor="bg-success dark:bg-green-600" borderColor="border-success" hoverBg="hover:bg-green-400 dark-hover:bg-green-500" hoverBorder="hover:border-success-400" class="mt-10" icon="fat-arrow-right" type="submit">Save Changes</base-button>
            </FormulateForm>
            
        </div>

    </full-screen-overlay>
</template>

<script>
import { LayoutComponents } from '../components'
import { updateUser, uploadedProfilePicture } from "@/graphql/mutations";
import { uploadProfilePicture } from "@/graphql/queries";
import { me, loading, error } from '@/mixins'
import { BlockBlobClient } from "@azure/storage-blob";
import { auth } from "@/firebaseConfig";

export default {
    name: "UserSettings",
    metaInfo: {
      title: 'User Settings',
    },
    mixins: [
      LayoutComponents, me, loading, error
    ],
    data () {
      return {
          isSubmitting: false,
          errors: {
              email: null
          }
      }
    },
    methods: {
        exit () {
            this.$router.push({ name: 'Project', params: { ...this.$route.params }, query: { ...this.$route.query } });
        },
        async uploadFile(file, progress, error, option) {
            try {
                const presignedUrlObject = await this.$apollo.query({
                        query: uploadProfilePicture
                    });


                const presignedUrl = presignedUrlObject.data.uploadProfilePicture.presignedUrl
                const blockBlobClient = new BlockBlobClient(presignedUrl);

                 const uploaded = await blockBlobClient.uploadBrowserData(file, 
                { blobHTTPHeaders: 
                    { blobContentType: file.type },
                    onProgress: (function progress(event) {
                        this.markProgress(parseInt(event.loadedBytes / this.fileSize * 100));
                    }).bind({ fileSize: file.size, markProgress: progress })
                } );

                const uploadedUser = await this.$apollo.mutate({
                    mutation: uploadedProfilePicture,
                    variables: {}
                });
                
                return [{ url: uploadedUser.data.uploadedProfilePicture.user.profilePictureUrl }];
            } catch (error) {
                this.handleError(error);
            }
        },
        async updateUser(data) {
          if (this.isSubmitting) {
              return
          }

          this.isSubmitting = true;
          this.errors = { email: null };

          this.$root.$emit('loading', true);

          try {
    
                if (data.email !== this.me.email) {
                    var user = auth.currentUser;
                    await user.updateEmail(data.email);
                }

                await this.$apollo.mutate({
                    mutation: updateUser,
                    variables: {
                        input: {
                            name: data.name
                        }
                    },
                });
            
            this.exit();
          } catch (error) {
            console.log('err', error);

            if (error.code === 'auth/requires-recent-login' || error.code === 'auth/email-already-in-use') {
                this.errors.email = error.message;
            }
          }

          this.$root.$emit('loading', false);

          this.isSubmitting = false;
      }
    }
}
</script>